import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const GET_MEMBER_LIST_QUERY = gql`
  query GetMemberList {
    getMemberList {
      cloudId
      fullName
      email
      active
      workflowRole
      administrator
      licensed
      roleName
      partner
      manager
    }
  }
` as import('../../__generated__/ts-gql/GetMemberList').type;

export type GetMemberListQueryVariables = OperationVariables<
  typeof GET_MEMBER_LIST_QUERY
>;
export type GetMemberListQueryResult = OperationData<
  typeof GET_MEMBER_LIST_QUERY
>;

export type GetMemberListItem = NonNullable<
  GetMemberListQueryResult['getMemberList']
>[number];

export const useGetMembersList = (
  options?: QueryHookOptions<GetMemberListQueryResult>
) => {
  const res = useQuery(GET_MEMBER_LIST_QUERY, {
    context: { service: 'users' },
    ...options,
  });

  // I don't really like sorting here, feels like sorting should happen in the calling code. But, it's also
  // a potentially expensive thing to do, we want to avoid this in a render loop
  // and a lot of the usage of this would need to be re-worked to avoid conditional hook usage
  // Also, if people refetch, they'll get data in different order :(
  return React.useMemo(
    () => ({
      ...res,
      data: (res.data?.getMemberList
        ? [...res.data.getMemberList].sort((a, b) =>
            (a.fullName || '').localeCompare(b.fullName || '', undefined, {
              sensitivity: 'base',
            })
          )
        : undefined) as GetMemberListItem[] | undefined,
    }),
    [res]
  );
};
